import { AvatarEntity } from '@datachain/ui-sdk/components/avatar';
import { immerable } from 'immer';

import dayjs, { Duration } from '../../../../core/configs/dayjs';
import { SubscriptionStatus } from '../../../domain/subscription.types';

interface IHistoryItemEntity {
	id: number;
	action: string;
	status: SubscriptionStatus;
	date: dayjs.Dayjs | null;
	duration: Duration | null;
	columnCount: number;
	lineCount: number;
	avatar: AvatarEntity | null;
}

const entityDefaults: IHistoryItemEntity = {
	id: -1,
	action: '',
	status: SubscriptionStatus.Unknown,
	date: null,
	duration: null,
	columnCount: 0,
	lineCount: 0,
	avatar: null,
};

export class HistoryItemEntity implements IHistoryItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public action = entityDefaults.action;
	public status = entityDefaults.status;
	public date = entityDefaults.date;
	public duration = entityDefaults.duration;
	public columnCount = entityDefaults.columnCount;
	public lineCount = entityDefaults.lineCount;
	public avatar = entityDefaults.avatar;

	public static build(params: Partial<IHistoryItemEntity>): HistoryItemEntity {
		const instance = new HistoryItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.action = params.action ?? entityDefaults.action;
		instance.status = params.status ?? entityDefaults.status;
		instance.date = params.date ?? entityDefaults.date;
		instance.duration = params.duration ?? entityDefaults.duration;
		instance.columnCount = params.columnCount ?? entityDefaults.columnCount;
		instance.lineCount = params.lineCount ?? entityDefaults.lineCount;
		instance.avatar = params.avatar ?? entityDefaults.avatar;

		return instance;
	}
}
